const objeto2 = {
    titulo: `Objetos: conceptos básicos de métodos`,
    problemas: [
        {
            codigo: 1,
            descripcion: `Un objeto además de definir atributos o propiedades que almacenan valores, pueden definir funciones o también llamados métodos que manipulan dichos atributos.
Igual que las atributos debemos dar un nombre al método y luego de los dos puntos seguimos con la definición del método.
Para acceder a los atributos desde los propios métodos debemos utilizar la palabra clave this. 
Luego podemos llamar a los métodos utilizando la notación de punto (.) igual que los atributos.`,
            programa: `const persona1 = {
  nombre: "Juan",
  apellido: "Perez",
  edad: 20,
  esMayorEdad: function () {
    if (this.edad >= 18) {
      console.log(this.nombre + " es mayor de edad")
    }
  },
  mostrarNombreCompleto: function () {
    console.log(this.nombre + ", " + this.apellido)
  }
}
      
persona1.esMayorEdad()`,
            solucion: "'Juan es mayor de edad'"
        }, {
            codigo: 2,
            descripcion: `La palabra clave this hace referencia al objeto que está invocando el método, en el ejemplo anterior la variable persona1.
Si nos olvidamos de la palabra clave this luego se genera un error sintáctico.`,
            programa: `const persona1 = {
  nombre: "Juan",
  apellido: "Perez",
  edad: 20,
  mostrarNombre: function () {
    console.log(nombre)
  }
}
      
persona1.mostrarNombre()`,
            solucion: ""
        }, {
            codigo: 3,
            descripcion: `También debemos anteceder la palabra clave this para llamar a otros métodos del mismo objeto.`,
            programa: `const persona1 = {
  nombre: "Juan",
  apellido: "Perez",
  edad: 20,
  esMayor: function () {
    if (this.edad >= 18) {
      this.mensajeMayor()
    } else {
      this.mensajeMenor()
    }
  },
  mensajeMayor: function () {
    console.log("Es mayor de edad")
  },
  mensajeMenor: function () {
    console.log("Es menor de edad")
  }
}
      
persona1.esMayor()`,
            solucion: "'Es mayor de edad'"
        },
        {
            codigo: 4,
            descripcion: ``,
            programa: `const cuadrado1 = {
  lado: 20,
  retornarPerimetro: function () {
    return this.lado * 4
  },
  retornarSuperficie: function () {
    return this.lado * this.lado
  }
}
          
console.log(cuadrado1.retornarPerimetro())`,
            solucion: "80"
        }, {
            codigo: 5,
            descripcion: `El empleo de this es fundamental cuando tenemos más de un objeto que debemos asociar un mismo método.
Declaramos la función fuera de los dos objetos y luego los asociamos al crear los objetos (evitamos tener que codificar el mismo método dos veces).`,
            programa: `const articulo1 = {
  codigo: 1,
  descripcion: "Papas",
  precio: 2.5,
  imprimir: imprimir
}
          
const articulo2 = {
  codigo: 2,
  descripcion: "Manzanas",
  precio: 3.5,
  imprimir: imprimir
}
          
function imprimir() {
  console.log(this.codigo + " " + this.descripcion + " " + this.precio)
}
          
articulo2.imprimir()`,
            solucion: "'2 Manzanas 3.5'"
        }
    ]
}

export default objeto2;